import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const InfoModal = ({ titleIcon, title, bodyContent, show, footerContent, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className={titleIcon}/> {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodyContent}
            </Modal.Body>
            <Modal.Footer>
                {footerContent}
                {!footerContent && onClose &&
                    <Button variant="light" onClick={onClose}>
                        Close
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default InfoModal
